// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `svg.diff-removed {
  background: #E56283;
}

.diff-removed.djs-element:not(.djs-connection) > .djs-visual > :nth-child(1) {
  fill: #E56283 /* light-red */ !important;
}

.diff-removed.djs-connection > .djs-visual > :nth-child(1) {
  stroke: #BB163F /* red */ !important;
}

.marker.marker-removed {
  background: #BB163F /* red */;
}

svg.diff-added {
  background: #90DD5F;
}

.diff-added.djs-element:not(.djs-connection) > .djs-visual > :nth-child(1) {
  fill: #90DD5F /* light-green */!important;
}

.diff-added.djs-connection > .djs-visual > :nth-child(1) {
  stroke: #54B415 /* green */ !important;
}

.marker.marker-added {
  background: #54B415 /* green */;
}

svg.diff-layout-changed {
  background: #4D79A3;
}

.diff-layout-changed.djs-element:not(.djs-connection) > .djs-visual > :nth-child(1) {
  fill: #4D79A3 /* light-blue */ !important;
}

.diff-layout-changed.djs-connection > .djs-visual > :nth-child(1) {
  stroke: #185085 /* blue */ !important;
}

.marker.marker-layout-changed {
  background: #185085 /* blue */;
}

svg.diff-changed {
  background: #FBC16C;
}

.diff-changed.djs-element:not(.djs-connection) > .djs-visual > :nth-child(1) {
  fill: #FBC16C /* light-yellow */ !important;
}

.diff-changed.djs-connection > .djs-visual > :nth-child(1) {
  stroke: #CD8318 /* yellow */ !important;
}

.marker.marker-changed {
  background: #CD8318 /* yellow */;
}
`, "",{"version":3,"sources":["webpack://./client/diff/css/diff.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;AACrB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,gCAAgC;AAClC","sourcesContent":["svg.diff-removed {\n  background: #E56283;\n}\n\n.diff-removed.djs-element:not(.djs-connection) > .djs-visual > :nth-child(1) {\n  fill: #E56283 /* light-red */ !important;\n}\n\n.diff-removed.djs-connection > .djs-visual > :nth-child(1) {\n  stroke: #BB163F /* red */ !important;\n}\n\n.marker.marker-removed {\n  background: #BB163F /* red */;\n}\n\nsvg.diff-added {\n  background: #90DD5F;\n}\n\n.diff-added.djs-element:not(.djs-connection) > .djs-visual > :nth-child(1) {\n  fill: #90DD5F /* light-green */!important;\n}\n\n.diff-added.djs-connection > .djs-visual > :nth-child(1) {\n  stroke: #54B415 /* green */ !important;\n}\n\n.marker.marker-added {\n  background: #54B415 /* green */;\n}\n\nsvg.diff-layout-changed {\n  background: #4D79A3;\n}\n\n.diff-layout-changed.djs-element:not(.djs-connection) > .djs-visual > :nth-child(1) {\n  fill: #4D79A3 /* light-blue */ !important;\n}\n\n.diff-layout-changed.djs-connection > .djs-visual > :nth-child(1) {\n  stroke: #185085 /* blue */ !important;\n}\n\n.marker.marker-layout-changed {\n  background: #185085 /* blue */;\n}\n\nsvg.diff-changed {\n  background: #FBC16C;\n}\n\n.diff-changed.djs-element:not(.djs-connection) > .djs-visual > :nth-child(1) {\n  fill: #FBC16C /* light-yellow */ !important;\n}\n\n.diff-changed.djs-connection > .djs-visual > :nth-child(1) {\n  stroke: #CD8318 /* yellow */ !important;\n}\n\n.marker.marker-changed {\n  background: #CD8318 /* yellow */;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
